import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { NgbActiveModal, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { Button, PopUpTitles, VplOemId } from "../../model/enum";
import { AgGridService } from "../ag-grid/ag-grid.service";
import { UpdateQuickNotes } from "../ag-grid/ag-grid.model";
import { CrmService } from "src/app/components/crm/crm.service";
import { ToastrService } from "ngx-toastr";
import { StingToDateService } from "../../services/stringToDate.service";
import { SendDataService } from "../../services/send-data.service";
import { VendorPartsLibraryService } from "../../../components/parts-and-inventory/vendor-parts-library/pages/vendor-parts-library/vendor-parts-library.service";
import { CompaniesService } from "../../../components/crm/companies/pages/companies/companies.service";
@Component({
  selector: "app-common-model-pop-up",
  templateUrl: "./common-model-pop-up.component.html",
  styleUrls: ["./common-model-pop-up.component.scss"],
})
export class CommonModelPopUpComponent implements OnInit,OnDestroy {
  @Input() fullName: string;
  @Input() title: string;
  @Input() pageType:string;
  @Input() ResMsgFromCompanyOrContact:string;
  @Input() currentTab:string;
  @Input() message: string;
  @Input() templateName: string;
  @Input() notes: string;
  @Input() companyId: string;
  @Input() deleteForAdmin:boolean=false;
  @Input() data: any;
  expirationDate: any;
   minDate: NgbDate;

  formattedExpirationDate: string = '';
  @Output() delPopupforAdmin: EventEmitter<any> = new EventEmitter();
  enumPopUpTitles = PopUpTitles;
  // enumButton = Button;
  enumButtonName = Button;
//  deleteForAdmin:boolean=false;
  quickNotes = new  UpdateQuickNotes();

  constructor(public activeModal: NgbActiveModal,public crmService: CrmService,public toaster: ToastrService,
    public agGridService: AgGridService,
    public stringToDateService: StingToDateService,public sendDataService: SendDataService,
     public vplService: VendorPartsLibraryService,
      public companiesService   : CompaniesService,
  ) {}

  ngOnInit(): void {
    if(this.title === this.enumPopUpTitles.VENDOR_PART_ACTIVE || this.title === this.enumPopUpTitles.LINE_ACTIVE){
      const today = new Date();
      this.minDate = new NgbDate(today.getFullYear(), today.getMonth() + 1, today.getDate());
    }
    this.quickNotes.notes =  this.notes 
    this.initialData()
    this.getConfirmMessage()

  //   if (this.fullName) {
  //   this.fullName = this.formatName(this.fullName);
  //  }
  }
  getConfirmMessage(){
    if(this.title == this.enumPopUpTitles.DELETE)
      this.sendDataService.getDeletedMesage().subscribe(res=>{
        if(res?.isSuccess){
          this.deleteForAdmin=true;
          this.ResMsgFromCompanyOrContact = res?.message
        }
      })
  }
  initialData(){
    if (this.data?.expirationDate && typeof this.data?.expirationDate === "string") {
       let datePart = this.data?.expirationDate.split('T')[0];
       if (datePart.includes('-')) {
         const parts = datePart.split('-');
         if (parts.length === 3) {
           datePart = `${parts[1]}/${parts[2]}/${parts[0]}`;
         }
       }
       this.formattedExpirationDate = datePart;
       this.data.expirationDate = this.stringToDateService.convertStringToDate(this.formattedExpirationDate)
    } 
    // else if(this.getAllDropDownModel?.fromDate){
    //   this.expirationDate  = this.stringToDateService.convertStringToDate(this.getAllDropDownModel?.fromDate)
    // }

    if(this.data){
     // this.title = this.data.title
    }
  }
  deletePopup(){
    this.delPopupforAdmin.emit(true);
    // setTimeout(() => {
    // this.deleteForAdmin=true;
    // }, 1000);
    
  }
  closedPopup(){
    this.agGridService.unChecked.next(false);
  }
  notesUpdate(){
    if(!this.companyId){
      this.activeModal.close({ quickNotes: this.quickNotes.notes, confirm: true });
      return
    }
    this.quickNotes.companyId = this.companyId;
    this.crmService.updatequicknote(this.quickNotes).subscribe(res=>{
      if(res.isSuccess){
        this.toaster.success(res.message);
        this.activeModal.close({ message: res.response, confirm: true });
      }else{
        this.toaster.error(res.message);
        this.activeModal.close('Close click')

      }
    })
  }
  onConfirmClick(date){
    let vendorOemId  =  this.data?.vendorOemId ?? VplOemId.VPL
        this.data.submit = true
        if(date && !this.data.expirationDate)return
        let request = {
          ids: this.data?.selectedData??[],
          expirationDate: date && this.data.expirationDate ? this.stringToDateService.dateConvertedToString(this.data.expirationDate): '',
          vendorOemId: vendorOemId
        }
        this.vplService?.updateExpirationDate(request).subscribe({
          next: (res) => {
            if (res?.isSuccess) {
              this.toaster.success(res?.message)
              this.activeModal.close({res:res,confirm:true})
            }
          },
          error: () => {}
        });
  }
  onExpirationDateChange(event) {
    this.data.expirationDate = event;
    this.formattedExpirationDate = this.stringToDateService.dateConvertedToString(event);
  }
  ngOnDestroy(){
    if(this.title == this.enumPopUpTitles.DELETE)
    this.sendDataService.setDeletedMesage(undefined)
  }

//  formatName(value: string): string {
//    if (!value) return '';
//    return value.charAt(0).toUpperCase() + value.slice(1);
//  }
get articleForPageType(): string {
  const word = this.pageType?.trim().toLowerCase();
  return /^[aeiou]/.test(word) ? 'an' : 'a';
}

}
